{
  "survey-number": "número de encuesta",
  "survey-information": "información de la encuesta",
  "land-only": "Solo tierra",
  "leasehold": "Arrendamiento",
  "commercial-le": "Arrendamiento comercial",
  "manufactured": "Casa prefabricada",
  "mobile-home": "Casa móvil",
  "wetlands": "Humedales"
}
